(() => {
  const root = document.querySelector('[data-mediakit]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const cards = Array.from(root.querySelectorAll('[data-mk-card]'));
  const search = root.querySelector('[data-mk-search]');
  const filters = Array.from(root.querySelectorAll('[data-mk-filter]'));
  const count = root.querySelector('[data-mk-count]');
  const shown = root.querySelector('[data-mk-shown]');
  const empty = root.querySelector('[data-mk-empty]');
  const more = root.querySelector('[data-mk-more]');
  const reset = root.querySelector('[data-mk-reset]');
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  cards.forEach(card => { card.searchText = normalize(card.dataset.search); });
  const order = () => {
    cards.sort((a, b) => a.searchText.localeCompare(b.searchText, 'es'));
    root.querySelector('[data-mk-grid]').append(...cards);
  };
  order();
  let category = 'all';
  let resource = 'all';
  let limit = 24;
  const render = () => {
    const words = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
    const matched = cards.filter(card => {
      const categoryMatch = category === 'all' || card.dataset.category === category;
      const image = card.dataset.images === 'true';
      const video = card.dataset.videos === 'true';
      const resourceMatch = resource === 'all' || (resource === 'images' && image) || (resource === 'videos' && video) || (resource === 'pending' && (!image || !video));
      return categoryMatch && resourceMatch && words.every(word => card.searchText.includes(word));
    });
    const visible = new Set(matched.slice(0, limit));
    cards.forEach(card => { card.hidden = !visible.has(card); });
    filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.group === 'category' ? button.dataset.value === category : button.dataset.value === resource)));
    count.textContent = `${matched.length} ${matched.length === 1 ? 'producto' : 'productos'}`;
    shown.textContent = matched.length ? `Mostrando ${visible.size} de ${matched.length} productos` : '';
    empty.hidden = matched.length !== 0;
    more.hidden = matched.length <= limit;
    reset.hidden = !(search.value || category !== 'all' || resource !== 'all');
    root.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
  };
  search.addEventListener('input', () => { limit = 24; render(); });
  filters.forEach(button => button.addEventListener('click', () => {
    if (button.dataset.group === 'category') category = button.dataset.value;
    else resource = button.dataset.value;
    limit = 24;
    render();
  }));
  more.addEventListener('click', () => { limit += 24; render(); });
  reset.addEventListener('click', () => { search.value = ''; category = 'all'; resource = 'all'; limit = 24; render(); search.focus(); });
  root.querySelectorAll('details').forEach(detail => detail.addEventListener('toggle', () => {
    if (detail.open) root.querySelectorAll('details[open]').forEach(other => { if (other !== detail) other.open = false; });
  }));
  document.addEventListener('click', event => {
    if (!event.target.closest('.mk-asset')) root.querySelectorAll('details[open]').forEach(detail => { detail.open = false; });
  });
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape') root.querySelectorAll('details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); });
  });
  render();
  // The verified registry is complete in initial HTML. Refresh only public names,
  // images and product URLs; media/SKU matching stays tied to its audited source.
  if (location.hostname !== '127.0.0.1' && location.hostname !== 'localhost') {
    fetch('/products.json?limit=250', { credentials: 'omit' })
      .then(response => { if (!response.ok) throw new Error('Catalog unavailable'); return response.json(); })
      .then(data => {
        if (!Array.isArray(data.products)) return;
        const catalog = new Map(data.products.map(product => [String(product.id), product]));
        cards.forEach(card => {
          const product = catalog.get(card.dataset.productId);
          if (!product || !product.title || !product.handle) return;
          const title = card.querySelector('.mk-card__title a');
          const photo = card.querySelector('.mk-card__photo');
          title.textContent = product.title;
          title.href = `/products/${product.handle}`;
          photo.href = title.href;
          photo.setAttribute('aria-label', `Ver ${product.title}`);
          const image = photo.querySelector('img');
          image.alt = product.title;
          if (product.images && product.images[0] && product.images[0].src) {
            const imageUrl = new URL(product.images[0].src, location.origin);
            imageUrl.searchParams.set('width', '600');
            if (image.src !== imageUrl.href) image.src = imageUrl.href;
          }
          card.dataset.search = `${product.title} ${card.querySelector('.mk-card__sku').textContent} ${card.querySelector('.mk-card__category').textContent}`;
          card.searchText = normalize(card.dataset.search);
        });
        order();
        render();
      })
      .catch(() => { /* Keep the verified server-rendered registry usable offline. */ });
  }
})();
